import React from "react";
import {
  agruparRowsPorApartado,
  aplanarRowsEnOrdenVisual,
  filaBloqueadaPorJustificacionPendiente,
  requiereJustificacionCalificacion,
  justificacionCumpleMinimo,
  MIN_CARACTERES_JUSTIFICACION,
  aplicarCambioJustificacionSecuencial,
} from "../utils/instrumentoRows";

const thStyle = {
  background: "#1E2A3A",
  color: "#FFFFFF",
  padding: "0.6rem 0.4rem",
  textAlign: "center",
  fontWeight: "bold",
  fontSize: "0.9rem",
  height: "24px",
  borderTop: "1px solid #1E2A3A",
  borderLeft: "1px solid #243447",
  borderBottom: "1px solid #243447",
  borderRight: "1px solid rgba(51,51,51,0.5)",
};

const CompetenciasTableBoss = ({
  rows,
  handleSelectChange,
  setRows,
  setFormTouched,
  getCalificationErrorStyle,
  calcularPromedioCompetencias,
}) => {
  const grupos = agruparRowsPorApartado(rows || []);
  const ordenVisual = aplanarRowsEnOrdenVisual(rows);
  const indexPorId = new Map(ordenVisual.map((r, i) => [r.id, i]));

  if (!rows || rows.length === 0) {
  return (
    <>
        <hr className="evaluation-hr" />
        <section className="evaluation-section">
          <p style={{ padding: "1rem", color: "#666" }}>
            Cargando competencias según el nivel organizacional del cargo…
          </p>
        </section>
      </>
    );
  }

  return (
    <>
      <hr className="evaluation-hr" />
      <section className="evaluation-section">
        <table className="evaluation-table competencias-table">
            <thead>
              <tr>
                <th
                  colSpan={7}
                  style={{
                    background: "linear-gradient(90deg, #1F3B73 0%, #0A0F1A 100%)",
                    color: "#FFFFFF",
                    padding: "0.8rem 1rem",
                    textAlign: "center",
                    fontSize: "1.1rem",
                    fontWeight: "bold",
                    height: "28px",
                  borderBottom: "1px solid rgba(0,0,0,0.25)",
                  }}
                >
                  COMPETENCIAS
                </th>
              </tr>
            <tr>
              <th style={{ ...thStyle, width: "12%" }}>COMPETENCIA</th>
              <th style={{ ...thStyle, width: "18%" }}>DEFINICIÓN DE LA COMPETENCIA</th>
              <th style={{ ...thStyle, width: "20%" }}>ASPECTO A EVALUAR</th>
              <th style={{ ...thStyle, width: "10%" }}>AUTOEVALUACIÓN</th>
              <th style={{ ...thStyle, width: "15%" }}>JUSTIFICACIÓN EMPLEADO</th>
              <th style={{ ...thStyle, width: "10%" }}>JEFE</th>
              <th style={{ ...thStyle, width: "15%" }}>JUSTIFICACIÓN JEFE</th>
              </tr>
            </thead>
            <tbody>
            {grupos.map((grupo, grupoIdx) =>
              grupo.items.map((row, idx) => {
                const esInicioGrupo = idx === 0;
                const flatIndex = indexPorId.get(row.id) ?? 0;
                const bloqueada = filaBloqueadaPorJustificacionPendiente(
                  ordenVisual,
                  flatIndex,
                  "boss"
                );
                const filaClase = [
                  "competencia-fila",
                  esInicioGrupo ? "competencia-fila--inicio" : "",
                  grupoIdx % 2 === 0 ? "competencia-fila--par" : "competencia-fila--impar",
                  bloqueada ? "competencia-fila--bloqueada" : "",
                ]
                  .filter(Boolean)
                  .join(" ");

                return (
                  <tr key={row.id} className={filaClase}>
                    {esInicioGrupo && (
                      <>
                        <td
                          rowSpan={grupo.items.length}
                          className="competencia-nombre-cell"
                        >
                          {grupo.apartado}
                </td>
                <td
                          rowSpan={grupo.items.length}
                          className="competencia-definicion-cell"
                        >
                          {grupo.definicion}
                </td>
                      </>
                    )}
                    <td className="competencia-aspecto-cell">{row.aspecto}</td>
                    <td className="competencia-auto-cell">
                      {row.worker || "-"}
                </td>
                    <td className="competencia-justif-readonly-cell">
                      <div className="competencia-justif-readonly">
                        {requiereJustificacionCalificacion(row.worker)
                          ? row.justificacionTrabajador || "—"
                          : "—"}
                  </div>
                </td>
                    <td className="competencia-calif-cell">
                  <select
                    className="rating-select"
                        value={row.boss === 0 ? "" : row.boss}
                        onChange={(e) => handleSelectChange(row.id, "boss", e.target.value)}
                        style={getCalificationErrorStyle(row.id, "boss")}
                        disabled={bloqueada}
                        title={
                          bloqueada
                            ? `Justifique la calificación anterior (1, 2 o 5) con al menos ${MIN_CARACTERES_JUSTIFICACION} caracteres`
                            : undefined
                        }
                      >
                        <option value="">Seleccione calificación</option>
                    <option value="1">1 - No Cumple</option>
                    <option value="2">2 - Regular</option>
                    <option value="3">3 - Parcial</option>
                    <option value="4">4 - Satisfactorio</option>
                    <option value="5">5 - Excelente</option>
                  </select>
                      {bloqueada && (
                        <small className="competencia-bloqueo-aviso">
                          Justifique la anterior (mín. {MIN_CARACTERES_JUSTIFICACION} caracteres)
                        </small>
                      )}
                </td>
                    <td className="competencia-justif-cell">
                      {requiereJustificacionCalificacion(row.boss) ? (
                        <>
                  <textarea
                            className={`justificacion-textarea${!justificacionCumpleMinimo(row.justificacionJefe) ? " justificacion-textarea--incompleta" : ""}`}
                    rows={2}
                            placeholder={`Mínimo ${MIN_CARACTERES_JUSTIFICACION} caracteres`}
                            value={row.justificacionJefe || ""}
                            onChange={(e) => {
                              setRows((prev) =>
                                aplicarCambioJustificacionSecuencial(
                                  prev,
                                  row.id,
                                  "boss",
                                  e.target.value
                                )
                              );
                      setFormTouched(true);
                    }}
                  />
                          <small
                            className={`competencia-justif-contador${!justificacionCumpleMinimo(row.justificacionJefe) ? " competencia-justif-contador--bajo" : ""}`}
                          >
                            {(row.justificacionJefe || "").trim().length}/{MIN_CARACTERES_JUSTIFICACION}
                          </small>
                        </>
                      ) : null}
                </td>
              </tr>
                );
              })
            )}
            <tr>
              <td
                colSpan={3}
                  style={{
                  backgroundColor: "#1E2A3A",
                  color: "#fff",
                    fontWeight: "bold",
                  textAlign: "right",
                  padding: "0.6rem",
                  }}
                >
                PROMEDIO COMPETENCIAS
                </td>
                <td
                colSpan={4}
                  style={{
                  backgroundColor: "#1E2A3A",
                  color: "#fff",
                    fontWeight: "bold",
                    textAlign: "center",
                  padding: "0.6rem",
                }}
              >
                {typeof calcularPromedioCompetencias === "function"
                  ? calcularPromedioCompetencias()
                  : "-"}
                </td>
              </tr>
            </tbody>
          </table>
        </section>
    </>
  );
};

export default CompetenciasTableBoss;
